import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const SearchOptions = ({
    favorited,
    setViewMode,
    viewMode,
    setFavorited,
    starred,
    setStarred,
    setFilterMine,
    filterMine,
    setOld,
    old
}) => { 
    return (
        <div className="search-options">
          <div
            onClick={() => setFilterMine(true)}
            className={filterMine ? "selected search-option": "search-option"}>
            My Projects
          </div>
          <div
            onClick={() => setFilterMine(false)}
            className={!filterMine ? "selected search-option": "search-option"}>
            All Projects
          </div>
          {<div
            onClick={() => setOld(!old)}
            className={old ? "selected search-option": "search-option"}>
             Old
           </div>}
          <div className="view-modes">
            <div
              onClick={() => setViewMode("LIST")}
              className={viewMode === "LIST" ? "selected view-mode" : "view-mode"}>
              <img src="/list-icon.svg"/>
            </div>
            <div
              onClick={() => setViewMode("GRID")}
              className={viewMode === "GRID" ? "selected view-mode" : "view-mode"}>
              <img src="/grid-icon.svg"/>
            </div>
          </div>
          {/*
          <div
            className={!favorited ? "heart" : "heart favorited"}
            onClick={() => setFavorited(!favorited)}>
          </div>
          <div
            className={!starred ? "star" : "star starred"}
            onClick={() => setStarred(!starred)}>
            <span>&#9734;</span>
          </div>
           */}
        </div>
    );
}



const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchOptions);
